import { removePropertyEmpty } from '@/utils/index'
import { Service } from '../config'

class MarkService extends Service {
  path = 'marca'

  async get(payload: any) {
    const httpResponse = this.httpClient.get(this.path, {
      params: removePropertyEmpty(payload)
    })
    return httpResponse
  }

  async download(payload: any) {
    const httpResponse = await this.httpClient.get(`${this.path}/excel`, {
      params: removePropertyEmpty(payload)
    })
    return httpResponse
  }

  async put(id: string, payload: any) {
    const httpResponse = await this.httpClient.put(
      `/${this.path}?marcaId=${id}`,
      payload
    )
    return httpResponse
  }

  async delete(id: string) {
    const httpResponse = await this.httpClient.delete(
      `${this.path}?marcaId=${id}`
    )
    return httpResponse
  }

  async post(payload: any) {
    const httpResponse = await this.httpClient.post(this.path, payload)
    return httpResponse
  }
}

export const markService = new MarkService()
